import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[min-height]',
  standalone: true,
  host: {
    '[style.min-height]': 'minHeight',
  }
})
export class MinHeightDirective {

  @Input({ alias: 'min-height' }) minHeight: string;
}
